import { ErrorHandler, Inject, NgZone, Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { NotificationService } from "./notification.service";
import { Observable } from "rxjs";

interface ErrorEntry {
  type: string;
  message: string;
  stack: any;
  location: string;
}
@Injectable()
export class ErrorService extends ErrorHandler {
  handlers: ((error: ErrorEntry) => void)[];

  constructor(
    private http: HttpClient,
    @Inject(NotificationService) private notificationService: NotificationService,
    private zone: NgZone
  ) {
    super();

    // this.handlers = Object.keys(Object.getPrototypeOf(this))
    //   .filter((propertyName) => propertyName.endsWith("Handler"))
    //   .map((handlerName) => this[handlerName]);

    this.handlers = [Object.getPrototypeOf(this)["addNotificationHandler"]];
  }

  handleError(error: any): void {
    super.handleError(error);

    let errorEntry: ErrorEntry = {
      type: error.name,
      message: this.getMessage(error),
      stack: error.stack,
      location: window.location.href,
    };
    this.handlers.forEach((handler) => {
      try {
        handler.apply(this, [errorEntry]);
      } catch (handlingError) {
        console.group("Error Handler");
        console.warn("Error when trying to output error.");
        console.error(handlingError);
        console.groupEnd();
      }
    });
  }
  parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    const reader: FileReader = new FileReader();

    const obs = new Observable((observer: any) => {
      reader.onloadend = (e) => {
        observer.error(JSON.parse(reader.result as string));
        observer.complete();
      };
    });
    reader.readAsText(err.error);
    return obs;
  }
  getMessage(error: any): string {
    console.log(error);
    const unreachableMsg = "Unreachable server. Please check the network connection and try again.";
    let msg = "";
    // if (error instanceof HttpErrorResponse) {
    //   console.log(error);
    //   this.parseErrorBlob(error).subscribe((res) => {
    //     console.log(res);
    //   });
    // }

    if (error instanceof HttpResponse) {
      if (error.status === 0) msg = unreachableMsg;
      else msg = `${error.status} - ${error.statusText}.${(<any>error)._body}`;
    } else if (error.target && error.target.status == 0) {
      msg = unreachableMsg;
    } else if (error instanceof Error) {
      msg = error.message;
    } else if (typeof error == "string") {
      msg = error;
    } else {
      console.log(error);
      msg = error.toString();
    }

    return msg;
  }

  addNotificationHandler(error: ErrorEntry) {
    this.zone.run(() => this.notificationService.push(error.message, "error"));
  }

  sendErrorHandler(error: ErrorEntry) {
    // this.http.post('api/log', error)
    //     .subscribe(r => { }, (e) => console.log(e));
  }
}

export const ERROR_HANDLER_PROVIDERS = [{ provide: ErrorHandler, useClass: ErrorService }];
